var $ = require('jquery');
var WS = require('./ws.js');
require('jquery-match-height');

$(function () {
    $.fn.matchHeight._maintainScroll = true;

    /*

    Out of the box, the match height plugin was causing unwanted behavior when decreasing and increasing the
    browser width without refreshing. As the width shrank, element groups would typically get taller, causing
    inline heights to be added. When the width was subsequently increased, the previously added inline heights
    prevented the elements from being updated to their previously shorter height, resulting in extra white
    space in the layout.

    The below code addresses that issue by removing inline heights from element groups before each time the match
    height code is run.

    */
    $.fn.matchHeight._beforeUpdate = function (event, groups) {
        for (var i = 0; i < groups.length; ++i) {
            for (var j = 0; j < groups[i].elements.length; ++j) {
                $(groups[i].elements[j]).css('height', '');
            }
        }
    };

    var matchHeightInit = function () {
        var $this = $(this),
            targets = $this.data('ws-mh').split('|'),
            groupIndexes = [];


        for (var i = 0; i < targets.length; ++i) {
            var isByRow = false;

            if ($this.data('ws-mh-by-row') !== 'undefined') {
                isByRow = $this.data('ws-mh-by-row');
            }

            $this.find(targets[i].trim()).matchHeight({ byRow: isByRow }).addClass('ws-mh-target');
            groupIndexes.push($.fn.matchHeight._groups.length - 1);
        }

        $this.data('ws-mh-group-indexes', groupIndexes.join('|'));
    };

    // Match height causes issues in Experience Editor, so don't enable it there, except for those listed as exceptions
    var matchHeightSelector = '[data-ws-mh]' + (WS.isExperienceEditor() ? '[data-ws-mh-allow-in-ee="true"]' : '');

    $(matchHeightSelector + ':not(.lazyload)').each(function (index, item) {
        matchHeightInit.apply(item);
    });

    $(document).on('lazyloaded', matchHeightSelector, function (e) {
        if (e.currentTarget === e.target) {
            matchHeightInit.apply(e.target);
        }
    });
});